/* tslint:disable */
/* eslint-disable */
// @generated
// This file was automatically generated and should not be edited.

//==============================================================
// START Enums and Input Objects
//==============================================================

export enum NotificationActionEnum {
  AmaRequestFulfillmentAction = "AmaRequestFulfillmentAction",
  AppUpdateAction = "AppUpdateAction",
  ArticleViewAction = "ArticleViewAction",
  BrandDealsListViewAction = "BrandDealsListViewAction",
  CampaignOfferApplyAction = "CampaignOfferApplyAction",
  CampaignOfferPublishAction = "CampaignOfferPublishAction",
  CampaignOfferViewAction = "CampaignOfferViewAction",
  ChannelStartAction = "ChannelStartAction",
  DashboardViewAction = "DashboardViewAction",
  InterviewCancelAction = "InterviewCancelAction",
  InterviewNowClipsReviewAction = "InterviewNowClipsReviewAction",
  InterviewNowStartAction = "InterviewNowStartAction",
  InterviewRescheduleAction = "InterviewRescheduleAction",
  InterviewScheduleAction = "InterviewScheduleAction",
  MediaFeedAthleteView = "MediaFeedAthleteView",
  MediaFeedShareAction = "MediaFeedShareAction",
  MediaFeedView = "MediaFeedView",
  MerchAddAction = "MerchAddAction",
  MerchAthleteView = "MerchAthleteView",
  MerchTemplateAction = "MerchTemplateAction",
  PostAiClipsReviewAction = "PostAiClipsReviewAction",
  PpvStreamClipsReviewAction = "PpvStreamClipsReviewAction",
  PpvStreamHighlightsWatchAction = "PpvStreamHighlightsWatchAction",
  ProductAddAction = "ProductAddAction",
  ProductAthleteView = "ProductAthleteView",
  ProductTemplateAction = "ProductTemplateAction",
  ProductTemplateLatestAction = "ProductTemplateLatestAction",
  ShareLatestMemorabiliaAction = "ShareLatestMemorabiliaAction",
  StreamJoinAction = "StreamJoinAction",
  StreamShareAction = "StreamShareAction",
  StreamStartAction = "StreamStartAction",
  StreamWatchAction = "StreamWatchAction",
  StreamWatchPastAction = "StreamWatchPastAction",
  TipPaymentVisibleAction = "TipPaymentVisibleAction",
  TipReceivedAction = "TipReceivedAction",
  VideoLabClipReviewAction = "VideoLabClipReviewAction",
}

export enum OrderDirection {
  asc = "asc",
  desc = "desc",
}

export interface GetNotificationsInput {
  nextToken?: string | null;
  limit?: number | null;
  direction?: OrderDirection | null;
}

export interface GetReadNotificationsInput {
  nextToken?: string | null;
  limit?: number | null;
  direction?: OrderDirection | null;
}

export interface GetUnreadNotificationsInput {
  nextToken?: string | null;
  limit?: number | null;
  direction?: OrderDirection | null;
}

export interface MarkNotificationsReadInput {
  ids: string[];
}

export interface RemoveNotificationsInput {
  ids: string[];
}

export interface UpsertDeviceFcmTokenInput {
  token: string;
}

//==============================================================
// END Enums and Input Objects
//==============================================================
